(() => {
  const fields = ['title', 'vendor', 'variants.sku'];
  const isScoped = value => /\b(?:title|vendor|variants\.sku):/i.test(value);
  const buildQuery = value => value.trim();
  const exclusions = '';
  const stripExclusions = value => value.replace(' AND variants.price:>0', '').replace(' AND -title:"已交流" AND -title:"已售出" AND -title:"已售完"', '');
  const current = new URL(window.location.href);
  const query = current.searchParams.get('q') || '';
  const displayQuery = current.searchParams.get('clh_query') || '';
  const searchPage = /\/search\/?$/.test(current.pathname);
  const branchSuffix = stripExclusions(query).match(/ AND tag:"(高雄店|台北店)"$/)?.[0] || '';
  const normalizedQuery = displayQuery ? buildQuery(displayQuery) + branchSuffix : '';
  if (searchPage && query.trim() && ((!isScoped(query) && !displayQuery) || query.includes(' AND variants.price:>0') || current.searchParams.get('filter.v.price.gte') !== '0.01' || current.searchParams.has('options[unavailable_products]') || (normalizedQuery && query !== normalizedQuery))) {
    if (!displayQuery && !isScoped(query)) current.searchParams.set('clh_query', query.trim());
    const base = normalizedQuery || (isScoped(query) ? stripExclusions(query) : buildQuery(query));
    const branch = base.match(/ AND tag:"(高雄店|台北店)"$/)?.[0] || '';
    current.searchParams.set('q', base.slice(0, base.length - branch.length) + exclusions + branch);
    current.searchParams.delete('options[unavailable_products]');
    current.searchParams.set('filter.v.price.gte', '0.01');
    current.searchParams.set('type', 'product');
    current.searchParams.delete('options');
    current.searchParams.set('options[prefix]', 'last');
    window.location.replace(current.href);
    return;
  }
  const restoreQuery = root => {
    if (!searchPage || !displayQuery || stripExclusions(query).replace(/ AND tag:"(高雄店|台北店)"$/, '') !== buildQuery(displayQuery)) return;
    for (const input of root.querySelectorAll('input[type="search"][name="q"]')) {
      if (input.value === query) input.value = displayQuery;
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.parentElement?.closest('script,style,textarea')) continue;
      if (node.nodeValue.includes(query)) node.nodeValue = node.nodeValue.split(query).join(displayQuery);
    }
    if (document.title.includes(query)) document.title = document.title.split(query).join(displayQuery);
  };
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[role="search"]')) return;
    const input = form.querySelector('input[type="search"][name="q"]');
    if (!input || !input.value.trim() || isScoped(input.value)) return;
    const destination = new URL(form.action, window.location.origin);
    if (destination.origin !== window.location.origin || !/\/search\/?$/.test(destination.pathname)) return;
    event.preventDefault();
    destination.search = new URLSearchParams(new FormData(form)).toString();
    destination.searchParams.set('clh_query', input.value.trim());
    destination.searchParams.set('q', buildQuery(input.value) + exclusions);
    destination.searchParams.delete('options[unavailable_products]');
    destination.searchParams.set('filter.v.price.gte', '0.01');
    destination.searchParams.set('type', 'product');
    destination.searchParams.delete('page');
    destination.searchParams.delete('options');
    destination.searchParams.set('options[prefix]', 'last');
    window.location.assign(destination.href);
  }, true);
  const ready = () => {
    restoreQuery(document.documentElement);
    const main = document.querySelector('#MainContent');
    if (main && searchPage && displayQuery) {
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        queueMicrotask(() => { queued = false; restoreQuery(main); });
      }).observe(main, {childList: true, subtree: true});
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
})();